import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PaginatedEnsueCollection } from "../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import { FootballOrganizer } from "../../../../../commons/models/football/football-organizer";
import { manageFootballOrganizerService } from "../../../../../commons";
import { StatusEnum } from "../../../../../commons/enums/status-enum";

export interface IFootballOrganizerListOptions {
  page?: number;
  perPage?: number;
  sort?: string;
  sortOrder?: "DESC" | "ASC";
  name?: string;
}

export interface IManageFootballOrganizerListState {
  footballOrganizerList: PaginatedEnsueCollection<FootballOrganizer>;
  footballOrganizerListStatus: StatusEnum;
}

const initialState: IManageFootballOrganizerListState = {
  footballOrganizerList: new PaginatedEnsueCollection<FootballOrganizer>(),
  footballOrganizerListStatus: StatusEnum.Idle,
};

export const fetchManageFootballOrganizerList = createAsyncThunk(
  "footballOrganizers/fetchManageFootballOrganizerList",
  async (options: IFootballOrganizerListOptions, thunkAPI) => {
    try {
      const footballOrganizerList = await manageFootballOrganizerService.list(undefined, {
        ...options,
      });
      return footballOrganizerList as PaginatedEnsueCollection<FootballOrganizer>;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageFootballOrganizerListSlice = createSlice({
  name: "manageFootballOrganizerList",
  initialState: initialState,
  reducers: {
    cleanUpFootballOrganizerList(state) {
      state.footballOrganizerList = new PaginatedEnsueCollection<FootballOrganizer>();
      state.footballOrganizerListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageFootballOrganizerList.pending, (state) => {
        state.footballOrganizerListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageFootballOrganizerList.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<FootballOrganizer>>) => {
          state.footballOrganizerListStatus = StatusEnum.Succeeded;
          state.footballOrganizerList = action.payload;
        }
      )
      .addCase(fetchManageFootballOrganizerList.rejected, (state) => {
        state.footballOrganizerListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpFootballOrganizerList } = manageFootballOrganizerListSlice.actions;
export default manageFootballOrganizerListSlice.reducer;
